<div class="card border rounded-lg p-4 shadow-sm bg-white">
  <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3 mb-3">
    <div>
      <h5 class="text-x fw-bold mb-1">Entity types</h5>
      <p class="text-muted text-xxs mb-0">
        Choose which entity types this PDF can be used for. The current profile type stays selected when you build from a profile.
      </p>
    </div>
    <span class="badge rounded-small bg-light text-dark text-xxs px-3 py-2 shadow-sm">
      {{ selected_entity_types.length }} selected
    </span>
  </div>

  <div class="row g-3">
    <div class="col-12 col-xl-5">
      <label class="modal-form-label form-label text-xxs">Search entity types</label>
      <input
        v-model.trim="entity_type_search"
        class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
        placeholder="Search entity types..."
        type="text"
      />

      <div v-if="selected_entity_types.length" class="mt-3">
        <p class="modal-form-label form-label text-xxs">Selected</p>
        <div class="d-flex flex-wrap gap-2">
          <span
            v-for="entity_type in selected_entity_types"
            :key="entity_type.id"
            class="badge rounded-small text-xxs px-3 py-2 shadow-sm"
            :class="is_locked(entity_type.id) ? 'bg-success text-white' : 'bg-light text-dark'"
          >
            {{ entity_type.entity_type_name }}
            <span v-if="is_locked(entity_type.id)"> · Current profile</span>
          </span>
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-7">
      <label class="modal-form-label form-label text-xxs">Available entity types</label>
      <div class="list-group rounded-small shadow-sm overflow-auto formal-entity-type-list">
        <label
          v-for="entity_type in filtered_entity_types"
          :key="entity_type.id"
          class="list-group-item list-group-item-action p-3"
          :class="{ 'bg-light': is_selected(entity_type.id) }"
        >
          <div class="d-flex align-items-start gap-3">
            <input
              :checked="is_selected(entity_type.id)"
              :disabled="is_locked(entity_type.id)"
              class="form-check-input shadow-sm mt-1"
              type="checkbox"
              @change="toggle(entity_type.id)"
            />
            <div class="flex-grow-1">
              <div class="d-flex flex-wrap align-items-center gap-2 mb-1">
                <span class="fw-semibold text-dark text-xxs">
                  {{ entity_type.entity_type_name }}
                </span>
                <span
                  v-if="is_locked(entity_type.id)"
                  class="badge rounded-small bg-light text-dark border text-xxs px-2 py-1"
                >
                  Current profile
                </span>
                <span
                  v-else-if="is_selected(entity_type.id)"
                  class="badge rounded-small bg-light text-dark text-xxs px-2 py-1"
                >
                  Selected
                </span>
              </div>
              <p class="text-muted text-xxs mb-0">
                {{
                  is_locked(entity_type.id)
                    ? "This entity type is locked because the builder was launched from this profile."
                    : "Include this entity type when the PDF should be reusable for it."
                }}
              </p>
            </div>
          </div>
        </label>

        <div v-if="!filtered_entity_types.length" class="p-3 text-muted text-xxs">
          No entity types match your search.
        </div>
      </div>
    </div>
  </div>
</div>
